import React from "react";

export default function ProfileSection() {
  return (
    <>
      <div className="profiles-bg py-16 sm:py-28 hidden lg:block md:block sm:hidden">
        <div className="container mx-auto text-center pb-11">
          <div className="text-white uppercase text-3xl sm:text-5xl font-black italic">
            {" "}
            Athlete & Coach Profiles
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-20 container mx-auto mb-16 px-4">
          <div className=" p-4 flex flex-row">
            <div className="ml-4 flex flex-col">
              <div className="uppercase text-white text-2xl font-medium text-left my-auto pb-8">
                Athlete Profiles
              </div>
              <p className="text-white uppercase text-3xl text-left font-black italic">
                Harvey Langi (LB)
              </p>
              <p className="text-gray-400 pt-2 pb-6">
                Bingham High School (2026)
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="mt-4">
                  <p className="text-white">Height</p>
                  <p className="text-left text-3xl text-red-500 mt-2 font-semibold">
                    6' 2"
                  </p>
                </div>
                <div className="mt-4">
                  <p className="text-white">Weight Class</p>
                  <p className="text-left text-3xl text-red-500 mt-2 font-semibold">
                    160-180
                  </p>
                </div>
                <div className="mt-4">
                  <p className="text-white">Bench Press</p>
                  <p className="text-left text-3xl text-red-500 mt-2 font-semibold">
                    23 reps
                  </p>
                </div>
                <div className="mt-4">
                  <p className="text-white">40 Yard Dash</p>
                  <p className="text-left text-3xl text-red-500 mt-2 font-semibold">
                    4.7 sec
                  </p>
                </div>
              </div>
            </div>
            <div className="relative top-20">
              <img alt="athlete profile" src="Athlete.png" className="h-80" />
            </div>
          </div>
          <div className="md:hidden text-gray-100  text-3xl"> &amp; </div>
          <div className="hidden md:flex items-center justify-center relative top-12">
            <div className="h-72 w-px bg-gray-500"></div>
            <div
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
                  bg-[#1E1E1E] rounded-full border border-gray-200 p-4 px-6 text-gray-100 text-4xl shadow-sm"
            >
              &amp;
            </div>
          </div>
          <div className="p-4 flex flex-row">
            <div className="relative top-20">
              <img alt="coach profile" src="Coach.png" className="h-80" />
            </div>
            <div className="ml-8 flex flex-col">
              <div className="uppercase text-white text-2xl font-medium text-left my-auto pb-8">
                {" "}
                Coach/University Profiles
              </div>
              <p className="text-white uppercase text-3xl text-left font-black italic">
                Kalani Sitake
              </p>
              <p className="text-gray-400 pt-2 pb-6">
                Bingham High School (2026)
              </p>
              <div className="grid grid-cols-2 gap-4 mt-4">
                <div className="mt-4">
                  <p className="text-white">University</p>
                  <p className="text-left text-3xl text-blue-700 mt-2 font-semibold">
                    BYU
                  </p>
                </div>
                <div className="mt-4">
                  <p className="text-white">Bowls</p>
                  <p className="text-left text-3xl text-blue-700 mt-2 font-semibold">
                    4-2
                  </p>
                </div>
                <div className="mt-4">
                  <p className="text-white">Record</p>
                  <p className="text-left text-3xl text-blue-700 mt-2 font-semibold">
                    63-41
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col profiles-bg py-16 sm:py-28  sm:hidden">
        <div className="container mx-auto text-center pb-11">
          <div className="text-white uppercase text-3xl sm:text-5xl font-black italic">
            {" "}
            Athlete & Coach Profiles
          </div>
        </div>
        {/* Cards */}

        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-4 px-4 xl:px-0">
          <div className="p-2">
            <div className="flex flex-col">
              <div className="uppercase text-white text-2xl font-medium text-center my-auto pb-8">
                Athlete Profiles
              </div>

              <div className="relative justify-items-center">
                <img
                  alt="athlete profile"
                  src="Athlete.png"
                  className="h-48 w-48"
                />
              </div>

              <p className="text-white uppercase text-2xl sm:text-3xl text-center font-black italic">
                Harvey Langi (LB)
              </p>
              <p className="text-gray-400 pt-2 pb-4 text-center">
                Bingham High School (2026)
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="mt-1">
                  <p className="text-white">Height</p>
                  <p className="text-left text-3xl text-red-500 mt-0 font-semibold">
                    6' 2"
                  </p>
                </div>
                <div className="mt-1 text-right">
                  <p className="text-white">Weight Class</p>
                  <p className="text-right text-3xl text-red-500 mt-0 font-semibold">
                    160-180
                  </p>
                </div>
                <div className="mt-1">
                  <p className="text-white">Bench Press</p>
                  <p className="text-left text-3xl text-red-500 mt-0 font-semibold">
                    23 reps
                  </p>
                </div>
                <div className="mt-1 text-right">
                  <p className="text-white">40 Yard Dash</p>
                  <p className="text-right text-3xl text-red-500 mt-0 font-semibold">
                    4.7 sec
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className=" relative">
            <div className="mt-0 mb-12 border-b text-center">
              <div className="leading-none px-4 py-3 inline-block text-4xl font-bold rounded-full text-gray-300 tracking-wide  bg-[#1E1E1E] border border-gray-200 transform translate-y-1/2">
                &
              </div>
            </div>
          </div>

          <div className="p-2">
            <div className="flex flex-col">
              <div className="uppercase text-white text-2xl font-medium text-center my-auto pb-8">
                Coach/University Profiles
              </div>

              <div className="relative justify-items-center">
                <img
                  alt="Coach profile"
                  src="Coach.png"
                  className="h-48 w-48"
                />
              </div>

              <p className="text-white uppercase text-2xl sm:text-3xl text-center font-black italic">
                Kalani Sitake
              </p>
              <p className="text-gray-400 pt-2 pb-4 text-center">
                Bingham High School (2026)
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="mt-1">
                  <p className="text-white">University</p>
                  <p className="text-left text-3xl text-blue-700 mt-0 font-semibold">
                    BYU
                  </p>
                </div>
                <div className="mt-1 text-right">
                  <p className="text-white">Bowls</p>
                  <p className="text-right text-3xl text-blue-700 mt-0 font-semibold">
                    4-2
                  </p>
                </div>
                <div className="mt-1">
                  <p className="text-white">Record</p>
                  <p className="text-left text-3xl text-blue-700 mt-0 font-semibold">
                    63-41
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
